/**
 * Define html contents mixin
 *
 * @author minkyoung.park@emcast.com
 */

//  check screen mode
function isPortrait() {
  if (screen.orientation === undefined) {
    return window.orientation === 0 || window.orientation === 180;
  } else {
    return screen.orientation.angle === 0;
  }
}

export const videoTypeMixins = {
  data() {
    return {
      sliderBottom: null,
      // Elements from HTML
      elementVideo: null,
      seekBar: null,
      seekBarTooltip: null,
      btnClose: null,

      playlistContainer: null,
      btnPlaylistClose: null,
      btnPlaylistToggle: null,

      currentSlideValue: 0,
      currentTimeParsed: "00:00",
      fullLength: "00:00",

      isPlaying: false,

      nextVideo: null,
      thumbnailURL: "",
      thumbnailCanvas: null,

      isPortrait: isPortrait(),
      mainTransitionName: "fade",
      isVideoVisible: true,
      isLecturesVisible: true,
      isControlsVisible: true,
      isSubtitlesVisible: false,
      isSubtitleSettingsVisible: false,
      isQnAVisible: false,
      isQuizVisible: false,
      isResourceVisible: false,
      isQuizContainerVisible: false,
      isLandscapOverlay: false,
      isSound: false,
      isPlayback: false,
      currentSound: 100,
      firstSubtitle: "",
      isQuestionAns: false,
      isControleOpen: false,
      pot: null
    };
  },

  mounted() {
    const elementHtml = document.querySelector("html");
    const elementBody = document.querySelector("body");
    const elementHeader = document.getElementById("portrait-view-header");

    this.elementVideo = document.getElementById("elementVideo");
    this.pot = document.getElementById("pot");

    // 화면 회전 이벤트 일 경우
    window.addEventListener("orientationchange", aaa => {
      this.isPortrait = isPortrait();

      if (!this.isPortrait) {
        // 세로 모드이면
        elementHtml.classList.add("no-scroll");
        elementBody.classList.add("no-scroll");
      } else {
        // 가로 모드이면
        elementHtml.classList.remove("no-scroll");
        elementBody.classList.remove("no-scroll");
      }

      // After orientationchange, add a one-time resize event
      // 화면 전환 후 상태 값 변경
      const afterOrientationChange = () => {
        setTimeout(() => {
          this.onOrientationChanged(false);
        }, 150); // Fix for iOS

        window.removeEventListener("resize", afterOrientationChange);
      };
      window.addEventListener("resize", afterOrientationChange);
    });

    this.isPortrait = isPortrait();

    if (!this.isPortrait) {
      elementHtml.classList.add("no-scroll");
      elementBody.classList.add("no-scroll");
    } else {
      elementHtml.classList.remove("no-scroll");
      elementBody.classList.remove("no-scroll");
    }

    this.elementVideo.crossOrigin = "Anonymous";

    this.seekBar = document.getElementById("seekBar");
    this.seekBarTooltip = document.getElementById("seekBarTooltip");

    this.thumbnailCanvas = document.createElement("canvas");
    this.thumbnailCanvas.width = 300;
    this.thumbnailCanvas.height = 200;

    this.playlistContainer = document.getElementById("playlistContainer");

    // 비디오 클릭시(video click)
    this.elementVideo.addEventListener("click", () => {
      if (!this.isPortrait) {
        if (!elementBody.classList.contains("overlay")) {
          elementBody.classList.add("overlay");
          elementHeader.classList.remove("d-landscape-none");
        } else {
          elementBody.classList.remove("overlay");
          elementHeader.classList.add("d-landscape-none");
        }
      } else {
        if (!this.isLandscapOverlay) {
          this.isLandscapOverlay = true;
        } else {
          this.isLandscapOverlay = false;
        }
      }
    });

    // 비디오 재생중(video play)
    this.elementVideo.addEventListener("play", () => {
      this.isPlaying = true;

      elementBody.classList.add("playing");
      elementBody.classList.remove("overlay");
    });

    // 비디오 일시정지(video pause)
    this.elementVideo.onpause = () => {
      this.isPlaying = false;
      elementBody.classList.remove("playing");
    };

    // 프로그레스 바 이동 후 썸네일 생성(vide seeked)
    this.elementVideo.onseeked = () => {
      const ctx = this.thumbnailCanvas.getContext("2d");
      ctx.fillStyle = "#000000";
      ctx.fillRect(
        0,
        0,
        this.thumbnailCanvas.width,
        this.thumbnailCanvas.height
      );
      ctx.drawImage(
        this.elementVideo,
        0,
        0,
        this.thumbnailCanvas.width,
        this.thumbnailCanvas.height
      );
      this.thumbnailURL = this.thumbnailCanvas.toDataURL(); // Update thumbnail on Tooltip
    };

    // 비디오 진도 바뀔때(video duration change)
    this.elementVideo.ondurationchange = () => {
      this.fullLength = this.parseSecondsToMinutes(this.elementVideo.duration);
    };

    let intCurrentTime = null;

    // 비디오 타임 업데이트(video time update)
    this.elementVideo.ontimeupdate = () => {
      this.currentSlideValue =
        (100 / this.elementVideo.duration) * this.elementVideo.currentTime;
      this.currentTimeParsed = this.parseSecondsToMinutes(
        this.elementVideo.currentTime
      );

      //  초마다 실행(run second)
      if (intCurrentTime !== parseInt(this.elementVideo.currentTime)) {
        intCurrentTime = parseInt(this.elementVideo.currentTime);
        let findTimelineContents = _.find(this.timelineContents, content => {
          return parseInt(content.position) === intCurrentTime;
        });

        let isChange = false;
        if (findTimelineContents) {
          isChange = true;
          this.currentTimelineContents = findTimelineContents;
        }

        if (isChange) {
          // 타임라인 컨텐츠가 있으면(when timeline contents)
          if (this.currentTimelineContents.type.value === "QUIZ") {
            // quiz
            this.isTimelineQuiz = true;
            this.isTimelineResource = false;
            this.elementVideo.pause();
          } else {
            // resource
            this.isTimelineQuiz = false;
            this.closeQuizDetail();
            this.isTimelineResource = true;
          }
        }

        // 10초마다 진도율 업데이트(when update progresion 10 second )
        if (intCurrentTime > 0 && intCurrentTime % 10 === 0) {
          this.updateProgress();
        }
      }
    };
  },

  methods: {
    exitPiPMode() {
      if (document.pictureInPictureElement) {
        this.elementVideo.pause();
        document.exitPictureInPicture();
      }
    },

    setPlaybackHandler() {
      this.isSound = false;
      this.isSubtitlesVisible = false;
      this.isPlayback = !this.isPlayback;
    },

    playBackItem(event) {
      document.querySelectorAll(".playBackItem").forEach(function(item) {
        item.firstElementChild.classList.add("d-none");
      });
      if (event.target.getAttribute("speed-data")) {
        event.target.firstElementChild.classList.toggle("d-none");
        this.elementVideo.playbackRate = event.target.getAttribute(
          "speed-data"
        );
      } else {
        event.target.lastElementChild.firstElementChild.classList.toggle(
          "d-none"
        );
        this.elementVideo.playbackRate = event.target.lastElementChild.getAttribute(
          "speed-data"
        );
      }
    },

    setSoundHandler() {
      this.isPlayback = false;
      this.isSubtitlesVisible = false;
      this.isSound = !this.isSound;
    },

    openFullscreen() {
      if (this.pot.requestFullscreen) {
        this.pot.requestFullscreen();
      } else if (this.pot.webkitRequestFullscreen) {
        /* Safari */
        this.pot.webkitRequestFullscreen();
      } else if (this.pot.msRequestFullscreen) {
        /* IE11 */
        this.pot.msRequestFullscreen();
      }
    },

    setFirstSubtitle(language) {
      if (this.firstSubtitle === language) {
        this.firstSubtitle = "";
      } else {
        this.firstSubtitle = language;
      }
      this.setSubtitles(this.firstSubtitle);
    },

    soundHandler() {
      this.setMaterialUi();
      this.elementVideo.volume = this.currentSound / 100;
    },

    setSubtitleHandler() {
      this.isPlayback = false;
      this.isSound = false;
      this.isSubtitlesVisible = !this.isSubtitlesVisible;
    },

    setisQuestionAns() {
      this.isQuestionAns = !this.isQuestionAns;
      if (this.isQuestionAns) {
        setTimeout(function() {
          document
            .querySelector(".video-bottom")
            .classList.add("video-chat-active");
          document.querySelector(".video-chat-wrapper").style.width = "460px";
          document.querySelector(".video-chat-wrapper").style.borderWidth =
            "1px";
          document.querySelector(".video-chat-wrapper").style.marginRight =
            "117px";
        }, 200);
      } else {
        setTimeout(function() {
          document
            .querySelector(".video-bottom")
            .classList.remove("video-chat-active");
          document.querySelector(".video-chat-wrapper").style.width = "0";
          document.querySelector(".video-chat-wrapper").style.borderWidth = "0";
          document.querySelector(".video-chat-wrapper").style.marginRight = "0";
        }, 200);
      }
    },
    onTogglePlayPause() {
      this.isPlaying ? this.elementVideo.pause() : this.elementVideo.play();

      this.elementVideoPriview = document.getElementById("elementVideoPriview");
      if (this.elementVideoPriview) {
        this.isPlaying
          ? this.elementVideoPriview.pause()
          : this.elementVideoPriview.play();
        //this.isPlaying = !this.isPlaying
      }

      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        // elementBody.,
      }
      //this.updateProgress()
    },

    onPlay() {
      this.togglePlayPause();
    },

    onPause() {
      this.togglePlayPause();
    },

    moveBackward(skipContents) {
      if (!skipContents) return;
      this.elementVideo.currentTime -= 10;
      this.elementVideoPriview = document.getElementById("elementVideoPriview");
      if (this.elementVideoPriview) {
        this.elementVideoPriview.currentTime -= 10;
      }
    },

    moveForward(skipContents) {
      if (!skipContents) return;
      this.elementVideo.currentTime += 10;
      this.elementVideoPriview = document.getElementById("elementVideoPriview");
      if (this.elementVideoPriview) {
        this.elementVideoPriview.currentTime += 10;
      }
    },

    onTogglePlaylist: function() {
      this.onOrientationChanged(true);
    },

    async openQuizDetail() {
      await this.closeResource();
      const elementBody = document.querySelector("body");
      elementBody.classList.add("quiz-overlay");
      this.mainTransitionName = "slide-up";
      if (this.isPortrait) {
        this.isVideoVisible = false;
        this.isControlsVisible = false;
        this.isSubtitlesVisible = false;
      } else {
        this.isVideoVisible = true;
        this.isControlsVisible = false;
      }
      this.isTimelineQuiz = false;
      this.isQuizVisible = true;
    },

    closeQuizDetail() {
      return new Promise(resolve => {
        const elementBody = document.querySelector("body");
        this.mainTransitionName = "slide-up";
        this.isVideoVisible = true;
        this.isControlsVisible = true;
        this.isQuizVisible = false;

        setTimeout(() => {
          elementBody.classList.remove("quiz-overlay");
          this.elementVideo.play();
          resolve();
        }, 500);
      });
    },

    async openResource() {
      // if (this.isQuizVisible) {
      await this.closeQuizDetail();
      // }

      const elementBody = document.querySelector("body");
      elementBody.classList.add("quiz-overlay");
      this.mainTransitionName = "slide-up";
      if (this.isPortrait) {
        this.isVideoVisible = false;
        this.isControlsVisible = false;
      }
      this.isTimelineResource = true;
    },

    closeResource() {
      return new Promise(resolve => {
        const elementBody = document.querySelector("body");
        this.mainTransitionName = "slide-up";
        this.isVideoVisible = true;
        this.isControlsVisible = true;
        this.isTimelineResource = false;

        setTimeout(() => {
          elementBody.classList.remove("quiz-overlay");
          resolve();
        }, 500);
      });
    },

    async onToggleQuiz() {
      if (this.isTimelineResource) {
        this.isTimelineResource = false;
        await this.onToggleResource();
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector("body");
        this.isTimelineQuiz = false;
        // document.getElementById('quizContainer').classList.remove('show');

        if (!elementBody.classList.contains("quiz-overlay")) {
          this.mainTransitionName = "slide-up";
          if (this.isPortrait) {
            this.isVideoVisible = false;
            this.isControlsVisible = false;
          }
          elementBody.classList.add("quiz-overlay");
          this.isQuizVisible = true;

          resolve();
        } else {
          this.mainTransitionName = "slide-up";
          this.isVideoVisible = true;
          this.isControlsVisible = true;
          this.isQuizVisible = false;

          setTimeout(() => {
            elementBody.classList.remove("quiz-overlay");
            resolve();
          }, 500);
        }
      });
    },

    async onToggleResource() {
      if (this.isQuizVisible) {
        this.isTimelineQuiz = false;
        this.isQuizVisible = false;
        await this.onToggleQuiz();
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector("body");

        if (!elementBody.classList.contains("quiz-overlay")) {
          this.mainTransitionName = "slide-up";
          if (this.isPortrait) {
            this.isVideoVisible = false;
            this.isControlsVisible = false;
          }
          elementBody.classList.add("quiz-overlay");
          this.isResourceVisible = true;
          resolve();
        } else {
          this.mainTransitionName = "slide-up";
          this.isVideoVisible = true;
          this.isControlsVisible = true;
          this.isResourceVisible = false;
          setTimeout(() => {
            elementBody.classList.remove("quiz-overlay");
            resolve();
          }, 500);
        }
      });
    },

    onToggleQnA: function() {
      const elementBody = document.querySelector("body");
      if (!elementBody.classList.contains("qna-overlay")) {
        this.mainTransitionName = "slide-up";
        this.isVideoVisible = false;
        this.isControlsVisible = false;

        setTimeout(() => {
          elementBody.classList.add("qna-overlay");
          this.isQnAVisible = true;
        }, 500);
      } else {
        setTimeout(() => {
          elementBody.classList.remove("qna-overlay");
          this.mainTransitionName = "slide-up";
          this.isVideoVisible = true;
          this.isControlsVisible = true;
          setTimeout(() => {
            this.mainTransitionName = "fade";
          }, 500);
        }, 500);
        this.isQnAVisible = false;
      }
    },
    onToggleSubtitles: function() {
      const elementBody = document.querySelector("body");
      if (!elementBody.classList.contains("subtitles-overlay")) {
        this.isVideoVisible = false;

        this.isSubtitlesVisible = true;
        elementBody.classList.add("subtitles-overlay");
        setTimeout(() => {
          this.elementVideo = document.getElementById("elementVideo");
          this.elementVideo.muted = true;
          this.elementVideoPriview = document.getElementById(
            "elementVideoPriview"
          );
          this.elementVideoPriview.src = this.elementVideo.src;
          this.elementVideoPriview.currentTime = this.elementVideo.currentTime;

          //this.elementVideo.src =  this.video.file
          //this.elementVideo.currentTime = this.recent
          // this.elementVideo.play()
          this.elementVideoPriview.play();
        }, 0);
      } else {
        this.isSubtitlesVisible = false;
        this.isVideoVisible = true;
        elementBody.classList.remove("subtitles-overlay");
        setTimeout(() => {
          this.elementVideo = document.getElementById("elementVideo");
          this.elementVideo.muted = false;
          // this.elementVideo = document.getElementById('elementVideo')
          // console.log('this.elementVideoPriview',this.elementVideo,this.video.file);
          // this.elementVideo.src =  this.video.file
          //this.elementVideo.currentTime = this.recent
          // this.elementVideo.play()
          // this.elementVideo.play()
        }, 0);
      }
      // const elementBody = document.querySelector('body')
      // if (!elementBody.classList.contains('subtitles-overlay')) {
      //     this.isVideoVisible = false;
      //     setTimeout(() => {
      //         this.isSubtitlesVisible = true;
      //         elementBody.classList.add('subtitles-overlay');
      //     }, 500);
      // } else {
      //     this.isSubtitlesVisible = false;
      //     setTimeout(() => {
      //         this.isVideoVisible = true;
      //         elementBody.classList.remove('subtitles-overlay');
      //     }, 500);
      // }
    },
    onToggleSubtitleSettings: function() {
      const elementBody = document.querySelector("body");
      if (!elementBody.classList.contains("subtitle-settings-overlay")) {
        this.mainTransitionName = "slide-up";
        this.isVideoVisible = false;
        this.isControlsVisible = false;
        this.isSubtitlesVisible = false;
        setTimeout(() => {
          elementBody.classList.add("subtitle-settings-overlay");
          this.isSubtitleSettingsVisible = true;
        }, 500);
      } else {
        setTimeout(() => {
          elementBody.classList.remove("subtitle-settings-overlay");
          elementBody.classList.remove("subtitles-overlay");
          this.mainTransitionName = "slide-up";
          this.isVideoVisible = true;
          this.isControlsVisible = true;
          setTimeout(() => {
            this.mainTransitionName = "fade";
          }, 500);
        }, 500);
        // if(!this.isVideoVisible){
        //     this.isSubtitlesVisible=true;
        // }
        this.isSubtitleSettingsVisible = false;
      }
    },
    onOrientationChanged: function(onClick) {
      const elementBody = document.querySelector("body");
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      const showInPortrait = () => {
        document.getElementsByTagName("html")[0].classList.remove("no-scroll");
        elementBody.classList.remove("no-scroll");

        this.playlistContainer.style.top = window.outerHeight - 50 + "px";
        this.playlistContainer.style.position = "absolute";

        const videoY = document.getElementById("videoContainer").clientHeight;
        setTimeout(() => {
          // To launch animation.
          this.playlistContainer.style.top = videoY + "px";
        }, 1);

        // document.querySelector('#lecturesTitle').innerHTML = 'Lectures';
        // document.querySelector('#lecturesTitle').classList.replace('typography--b4', 'typography--s4');
        document.getElementsByClassName("lectures-list")[0].style.height =
          window.outerHeight - videoY - 50 + "px";
      };

      const showInLandscape = () => {
        const marginX =
          1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        this.playlistContainer.style.top = "0";
        this.playlistContainer.style.left = "0";
        this.playlistContainer.style.position = "fixed";
        const lecturesList = document.getElementsByClassName("lectures-list")[0]
          .childNodes[0];
        const lectureWidth = lecturesList.childNodes[0].clientWidth;

        document.getElementsByClassName(
          "lectures-list"
        )[0].childNodes[0].style.width =
          (marginX + 24) * 2 +
          lectureWidth * lecturesList.childNodes.length +
          "px";

        document.getElementsByTagName("html")[0].classList.add("no-scroll");
        elementBody.classList.add("no-scroll");
      };

      if (this.playlistContainer.classList.contains("show")) {
        if (this.isPortrait) {
          document
            .getElementsByTagName("html")[0]
            .classList.remove("no-scroll");
          elementBody.classList.remove("no-scroll");

          if (onClick) {
            const style =
              this.playlistContainer.currentStyle ||
              window.getComputedStyle(this.playlistContainer);
            this.playlistContainer.style.top =
              window.outerHeight -
              50 +
              (window.outerHeight <= 568 ? parseInt(style.paddingTop, 10) : 0) +
              "px";

            setTimeout(() => {
              this.playlistContainer.classList.remove("show");
              this.showLectureList = false;
              this.playlistContainer.style.position = "initial";
              this.playlistContainer.style.top = "initial";
            }, 200);
          } else {
            document.getElementsByClassName(
              "lectures-list"
            )[0].childNodes[0].style.width = "initial";
            showInPortrait();
          }
        } else {
          if (onClick) {
            this.playlistContainer.style.top = "100vh";
            setTimeout(() => {
              this.mainTransitionName = "slide-up";
              this.isVideoVisible = true;
              this.isControlsVisible = true;
              this.playlistContainer.classList.remove("show");
              this.showLectureList = false;
              this.playlistContainer.style.position = "initial";
              setTimeout(() => {
                this.mainTransitionName = "fade";
              }, 500);
            }, 200);
          } else {
            showInLandscape();
          }
        }
      } else if (
        !this.playlistContainer.classList.contains("show") &&
        onClick
      ) {
        if (this.isPortrait) {
          if (onClick) {
            this.playlistContainer.classList.add("show");
            this.showLectureList = true;
          }

          showInPortrait();
        } else {
          if (onClick) {
            this.mainTransitionName = "slide-up";
            this.isVideoVisible = false;
            this.isControlsVisible = false;
            this.playlistContainer.style.top = "100vh";

            setTimeout(() => {
              this.playlistContainer.classList.add("show");
              this.showLectureList = true;
              showInLandscape();
            }, 200);
          } else {
            showInLandscape();
          }
        }
      }
    },

    onSliding: function(evt) {
      this.slidingVideoArr.push(this.elementVideo.currentTime);
      if (
        this.firstTrack &&
        this.firstTrack.cues.length > 0 &&
        this.slidingVideoArr[0] < this.firstTrack.cues[0].startTime
      ) {
        this.hideVideoTiSub = true;
      }
      this.elementVideo.currentTime =
        this.elementVideo.duration * (evt.target.value / 100);

      setTimeout(() => {}, 110); // To remove jumping effect of seekBarContainer because knob height is changing.

      console.log(this.elementVideo.currentTime);
      console.log(evt.target.value);
      if (parseInt(this.last) < parseInt(this.elementVideo.currentTime)) {
        this.currentSlideValue = (100 / this.elementVideo.duration) * this.last;
      }
    },

    onChanged: function() {
      console.log(this.last);
      console.log(this.elementVideo.currentTime);
      if (this.slidingVideoArr.length > 0) {
        this.slidingVideoArr = [];
      }
      if (parseInt(this.last) < parseInt(this.elementVideo.currentTime)) {
        this.currentSlideValue = (100 / this.elementVideo.duration) * this.last;
      }
    },

    parseSecondsToMinutes: function(seconds) {
      seconds = Math.round(seconds); // Need this to remove any numbers after period.
      let minutes = 0;
      while (seconds >= 60) {
        minutes++;
        seconds -= 60;
      }

      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      return minutes + ":" + seconds;
    }
  }
};
